import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { SPACES } from "@/lib/site";
import { TESTIDS } from "@/constants/testIds/site";

export const FeaturedSpaces = () => {
  return (
    <section className="bg-[var(--bg)]">
      <div className="mx-auto max-w-[1400px] px-6 md:px-12 lg:px-20 py-24 md:py-32">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6">
          <div>
            <div className="eyebrow">Featured spaces</div>
            <h2 className="section-title text-[44px] md:text-[64px] mt-3 leading-[1.02] max-w-3xl">
              Four ways to <em className="italic text-[var(--primary)]">work here</em>.
            </h2>
          </div>
          <Link to="/available-spaces" className="link-underline">
            Browse all spaces <ArrowUpRight size={15} />
          </Link>
        </div>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-2 gap-6">
          {SPACES.map((s, idx) => (
            <Link
              key={s.slug}
              to={`/spaces/${s.slug}`}
              data-testid={TESTIDS.spaceCard(s.slug)}
              className={`group hairline bg-white overflow-hidden flex flex-col ${
                idx % 3 === 0 ? "md:translate-y-0" : "md:translate-y-10"
              }`}
            >
              <div className="relative aspect-[16/11] overflow-hidden bg-[var(--border)]">
                <img
                  src={s.image}
                  alt={s.name}
                  loading="lazy"
                  className="absolute inset-0 w-full h-full object-cover transition-transform duration-[1200ms] group-hover:scale-[1.04]"
                />
              </div>
              <div className="p-7 md:p-9">
                <div className="text-[11px] tracking-[0.2em] uppercase text-[var(--text-muted)]">
                  {s.eyebrow}
                </div>
                <h3 className="font-serif text-[32px] md:text-[36px] mt-3 leading-tight tracking-tight">
                  {s.name}
                </h3>
                <p className="text-[15px] text-[var(--text-muted)] mt-3 max-w-md leading-relaxed">
                  {s.short}
                </p>
                <div className="mt-7 flex items-center justify-between">
                  <div className="flex items-baseline gap-2">
                    <span className="text-[13px] text-[var(--text-muted)] uppercase tracking-wider">
                      From
                    </span>
                    <span className="font-serif text-[26px] text-[var(--primary)]">
                      {s.startingRate}
                    </span>
                    <span className="text-[12px] text-[var(--text-muted)]">{s.rateUnit}</span>
                  </div>
                  <span className="link-underline border-none pb-0 group-hover:gap-3">
                    Explore <ArrowUpRight size={14} />
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturedSpaces;
